<div class="container">
  <div class="title">
    <h3>Set Your New Password</h3>
    <p>Please create a new password to complete your account setup.</p>
  </div>

  @if (successMessage) {
    <div class="message">
      <p-message severity="success" [text]="successMessage" />
    </div>
  }

  @if (errorMessage) {
    <div class="message">
      <p-message severity="error" [text]="errorMessage" />
    </div>
  }

  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="field">
      <p-input-group>
        <p-inputgroup-addon>
          <i class="pi pi-cog"></i>
        </p-inputgroup-addon>
        <p-floatlabel variant="on">
          <p-select
            formControlName="provider"
            [options]="availableProviders"
            optionLabel="label"
            id="provider"
            placeholder="Select authentication provider"
            [class.ng-invalid]="formGroup.get('provider')?.invalid && formGroup.get('provider')?.touched"
          />
          <label for="provider">Authentication Provider</label>
        </p-floatlabel>
      </p-input-group>
      @if (formGroup.get('provider')?.invalid && formGroup.get('provider')?.touched) {
        <small class="form-error">Please select an authentication provider</small>
      }
    </div>

    <div class="field">
      <p-input-group>
        <p-inputgroup-addon>
          <i class="pi pi-key"></i>
        </p-inputgroup-addon>
        <p-floatlabel variant="on">
          <input pInputText formControlName="newPassword" type="password" id="newPassword" />
          <label for="newPassword">New Password</label>
        </p-floatlabel>
      </p-input-group>
      @if (getPasswordError()) {
        <small class="form-error">{{ getPasswordError() }}</small>
      }
    </div>

    <div class="field">
      <p-input-group>
        <p-inputgroup-addon>
          <i class="pi pi-key"></i>
        </p-inputgroup-addon>
        <p-floatlabel variant="on">
          <input pInputText formControlName="confirmPassword" type="password" id="confirmPassword" />
          <label for="confirmPassword">Confirm New Password</label>
        </p-floatlabel>
      </p-input-group>
      @if (getConfirmPasswordError()) {
        <small class="form-error">{{ getConfirmPasswordError() }}</small>
      }
    </div>

    <div class="password-requirements">
      <h4>Password Requirements:</h4>
      <ul>
        <li>At least 8 characters long</li>
        <li>At least one lowercase letter</li>
        <li>At least one uppercase letter</li>
        <li>At least one number</li>
        <li>At least one special character (&#64;$!%*?&amp;)</li>
      </ul>
    </div>

    <p-divider />

    <div class="button-group">
      <p-button
        type="submit"
        label="Set New Password"
        [loading]="loading"
        [disabled]="!isValid() || loading"
        fluid="true"
      />
    </div>

    <div class="button-group">
      <p-button type="button" label="Back to Sign In" variant="outlined" (click)="goBackToSignIn()" fluid="true" />
    </div>
  </form>
</div>
